module.exports = __webpack_public_path__ + "static/media/avatar.e544cf62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar.svg
// module id = 617
// module chunks = 0